import { createAction } from '../../utils/helpers';
import * as actionTypes from './types';

export const resetPassword = createAction(actionTypes.RESET_PASSWORD);
export const resetPasswordSuccess = createAction(actionTypes.RESET_PASSWORD_SUCCESS);
